import React, {Fragment, useState, useEffect} from "react";

import {Row, Col} from "react-bootstrap";
import {useTranslation} from 'react-i18next';
import Cookies from 'js-cookie';
import {Checkmark} from 'react-checkmark';
import axios from "axios";
const { config } = require('../api/api')

function OmantelVisaHeader(){

    return(
        <>
        <nav class="navbar navbar-light bg-light">
        <div>
             <img class="navbar-brand mb-0 " style={{height:"60px",width:"171px"}} alt="omantel" src="https://omantel.sandbox-simplevisa.net/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsiZGF0YSI6IjY3MmJjOGIwLWQwMjMtNDBiNC1iNzdmLWFkNTY5MThjYjVlNCIsInB1ciI6ImJsb2JfaWQifX0=--9934e406305618c8254f37c9223560c15296e77e/Omantel.png"/>
             </div>
         </nav>
        </>
    )
}

export default OmantelVisaHeader;